<ng-container formContent>
  <h4 class="fs-28 bold mbn mtl">Choisissez librement vos supports.</h4>
  <span class="text-secondary fs-14">Un contrat à votre image.</span>

  <form [formGroup]="criteriaForm">
    <pr-input-abstract
      label="Type de support"
      class="mvl"
      style="display: block"
    >
      <mat-select
        formControlName="supportTypes"
        placeholder="Tous"
        [value]="'REALESTATE_FOUND'"
      >
        <mat-option [value]="undefined">Tous</mat-option>
        @for (type of supportTypes | async; track type) {
          <mat-option [value]="type.id">
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </pr-input-abstract>

    <pr-search-input
      formControlName="autocomplete"
      placeholder="Rechercher un support"
      class="mbm"
    >
    </pr-search-input>
  </form>
  <pr-form-select-list #formSelectList>
    @for (support of supports; track support) {
      <pr-form-select-list-option
        [label]="support.name"
        [labelIcon]="support.favorite ? 'sp-cup' : undefined"
        [subLabel]="support.isin"
        [selected]="
          _.map(
            form.get('avOptionInvestissementProgressifRepartition').value,
            'isin'
          ).includes(support.isin)
        "
        [criterias]="[
          { label: 'Performance', value: '~', options: { color: 'success' } },
          { label: 'Niveau de risque', value: '~' },
        ]"
        (onSelect)="onSupportSelect(support)"
        (onDeselect)="onSupportDeselect(support)"
        [withMoreInfoAnchor]="support.id"
        (onMoreInfoClick)="onMoreInfoClick(support)"
      >
      </pr-form-select-list-option>
    }
  </pr-form-select-list>
  <mat-paginator
    [length]="supportsLength"
    [pageSize]="supportsPageSize"
    (page)="changeSupportsPage($event)"
  >
  </mat-paginator>
</ng-container>
